import React from 'react'
import WatchSvg from '../../../img/svg/watch'
import { DeviceCard, DeviceName } from './index.styled'

const DeviceInfo = React.memo(({ watch }) => {
	if (!watch) return null

	return (
		<DeviceCard data-testid="device-card">
			<WatchSvg icon="device-check" />
			<DeviceName data-testid="device-name">{watch.deviceName}</DeviceName>
		</DeviceCard>
	)
})

DeviceInfo.displayName = 'DeviceInfo'
export default DeviceInfo
